import ReactDOM from 'react-dom';
import React from 'react';
import withModalTargetDetection from './withModalTargetDetection';
import './style/EmptyModalContainer.css';
import { MODAL } from 'app/ui/style/common/zindex';

/**
 * In most cases you will want to use the Modal component to render modal-type content.
 * However, in rare cases the modal content may need to be invisible to screen readers.
 * This doesn't play nice with the Modal, which puts a role on the overlay portion that
 * is still picked up by screen readers and is confusing. react-modal does not currently
 * support removing that attribute. This component renders an empty full-size container
 * into the same target that modals use.
 */
function EmptyModalContainer({ children, parentSelector, zIndex = MODAL }) {
  const content = (
    <div className="EmptyModalContainer" style={{ zIndex }}>
      {children}
    </div>
  );
  return ReactDOM.createPortal(content, parentSelector());
}

export default withModalTargetDetection(EmptyModalContainer);



// WEBPACK FOOTER //
// ./src/app/ui/core/common/EmptyModalContainer.js